
<div *arbAdminOnly class="select-realtor">
  <div class="progress">
    <mat-progress-bar *ngIf="isLoading$ | async" mode="indeterminate"></mat-progress-bar>
  </div>
  <!--
  <label class="arb-input">
    <span class="title">Select Realtor</span>
    <ng-select class="arb-select" [searchable]="false" [clearable]="false" (change)="onSelect($event)">
      <ng-option *ngFor="let re of realtor$ | async" [value]="re.id">{{re.firstName}}
        {{re.lastName}}
      </ng-option>
    </ng-select>
  </label>-->
  <label class="arb-input">
    <span class="title">Select Realtor</span>
    <input type="search"
    placeholder="Select One"
    aria-label="Number"
    matInput
    [formControl]="myControl"
    [matAutocomplete]="auto">
    <mat-autocomplete #auto="matAutocomplete" class="arb-select" (optionSelected)='selectOption($event)'>
      <mat-option *ngFor="let re of realtor$ | async" [value]="re.firstName" [id]="re.id" >
        {{re.firstName}} {{re.lastName}}
      </mat-option>
      <mat-option *ngIf="isFound">Not found</mat-option>
    </mat-autocomplete>
  </label>
</div>
<div class="toolbox-container">
  <div class="toolbox-header-container">
    <div>
      <p class="toolbox-header">Toolbox</p>&nbsp;&nbsp;&nbsp;
      
    </div>
    <div class="toolbox-right-column">
        <button
        *ngIf="useButton;"
        mat-flat-button
        color="primary"
        class="toolbox-category-add-default-button"
        (click)="viewSampleOffer()">View Sample Offer</button>

      <button
        *ngIf="useButton;"
        mat-flat-button
        color="primary"
        class="toolbox-category-add-default-button"
        (click)="openAddDefaultItems()"
        [disabled]="disableOnAddDefault$ | async">+ Default Items</button>
      <button
        *ngIf="useButton;"
        mat-flat-button
        color="primary"
        class="toolbox-category-add-button"
        (click)="openAddDialog()">+ New Item</button>
      <ng-template #text>
        <button class="add-item" (click)="openAddDialog()">+Add</button>
      </ng-template>
    </div>
  </div>
  <arb-message class="error" [message$]="message$"></arb-message>
  <div  class="toolbox-categories-list" 
  >
    <mat-expansion-panel *ngFor="let category of categories$ | async" 
      class="toolbox-category" 
      [expanded]="category.expanded"
      (opened)="category.expanded = true"
      (closed)="category.expanded = false" 
      
      >
      <mat-expansion-panel-header class="toolbox-category-header">
        <mat-panel-title class="toolbox-category-title">
          {{ category.name | borrowerLabel }}
          
        </mat-panel-title>
        <mat-panel-description  class="toolbox-category-item-number-container">
          <div class="toolbox-category-item-number"  >
            {{ (items$ | async | filterByCategory:category.id).length }}
          </div>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <div (cdkDropListDropped)="drop($event,category.id)" cdkDropList>
      <div  
        *ngFor="let item of items$ | async | filterByCategory:category.id"
        class="toolbox-item" cdkDrag>
        <p class="toolbox-item-text" >
          {{item.text}}
        </p>
        <div class="toolbox-item-buttons-container" > 
          <button class="plus-icon-btn transparent-button"
          *ngIf="isShowBtn('plus')"
          (click)="emitOfferTemplate({ ToolboxCategory: category, ToolboxItem: item });category.expanded = false">
            <span class="plus-icon">+</span>
          </button>

        <!-- <mat-icon
          class="toolbox-item-plus-button"
          svgIcon="plus"
          (click)="emitOfferTemplate({ ToolboxCategory: category, ToolboxItem: item })">
        </mat-icon> -->

          <mat-icon
            ngxClipboard
            *ngxClipboardIfSupported
            (cbOnSuccess)="onCopySuccess();category.expanded = false"
            [cbContent]="item.text"
            class="toolbox-item-copy-button"
            svgIcon="copy">
          </mat-icon>
         
          <mat-icon
            class="toolbox-item-edit-button"
            svgIcon="edit"
            (click)="openEditDialog(item.id, item.text, item.categoryId, category);">
          </mat-icon>

          <mat-icon
            class="toolbox-item-delete-button"
            svgIcon="delete"
            (click)="openDeleteDialog(item.id, category);">
          </mat-icon>
          
        </div>
      </div>
      </div>
    </mat-expansion-panel>
  </div>
</div>


<!-- <div class="email-signature-wrapper">
  <h4 class="title">Email Signature</h4>
  <div class="email-signature-container">
    <ckeditor [config]="CKEDITOR_CONFIG" (ready)="initializeEditor($event)" (change)="handleBodyChange($event)" [editor]="Editor"
    [data]="emailSignature">
    </ckeditor>
  </div>
  <div class="update-emailsig">
    <button mat-raised-button color="primary" (click)="updateEmailSignature()">+Update</button>
  </div>
</div> -->
